import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: ({ locale }, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/Internet/travel/hub/${locale?.toLowerCase()}/estimatedTaxesAndFees.json`,
    opts: {
      method: 'GET',
      credentials: 'omit',
    },
  }),
};
